import { render, staticRenderFns } from "./VerticalHighlightLayer.vue?vue&type=template&id=1c4bfdc4&"
import script from "./VerticalHighlightLayer.vue?vue&type=script&lang=js&"
export * from "./VerticalHighlightLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports